import React, { Suspense } from 'react';
import { useParams } from 'react-router-dom';
import { SubsWrapperSkeleton } from './SubsWrapper.skeleton';
import { useDynamicConfigs } from '../../../hooks/useDynamicConfigs';
const SubsWrapper = React.lazy(async () => await import('./SubsWrapper').then(({ SubsWrapper }) => ({ default: SubsWrapper })));
export const Subcollections = () => {
    const { hierarchyObjects } = useDynamicConfigs();
    const { handle = '' } = useParams();
    if (hierarchyObjects?.[handle] === undefined ||
        hierarchyObjects?.[handle].children.length < 1) {
        return null;
    }
    return (React.createElement(Suspense, { fallback: React.createElement(SubsWrapperSkeleton, { showTabs: hierarchyObjects[handle].subcollectionsAsTabs }) },
        React.createElement(SubsWrapper, { collectionObject: hierarchyObjects[handle] })));
};
